import React, {useMemo, useState} from 'react';
import {Table, Popup, Icon} from 'semantic-ui-react';
import {useTable, usePagination, useFilters, useRowSelect} from 'react-table';
import {Filter, DefaultColumnFilter} from '../../../common/components/tableFilters/index';
import AreaFormInput from './AreaForm';
import TablePaginator from '../../../common/components/reactTablePagination';


const columnsTableWithProps = (setEditArea, setAreaForm, cancelAddArea) => {
  return [
    {
      'Header': 'CODIGO',
      'accessor': 'primaryCode',
    },
    {
      'Header': 'DESCRIPCION',
      'accessor': 'description',
    },
    {
      'Header': 'ESTADO',
      'accessor': 'status',
      'disableFilters': true,
    },
    {
      'id': 'actions',
      'Header': 'ACCIONES',
      'Cell': ({row}) => {
        return (
          <Popup
            trigger={
              <Icon
                name="write"
                color="red"
                size="large"
                onClick={() => {
                  cancelAddArea();
                  setEditArea(row.index);
                  setAreaForm({...row.values});
                }}
              />
            }
            content="Editar"
            position="top center"
            inverted
          />
        );
      },
    },
  ];
};


const AreasTable = (props) => {
  const {list, addArea, cancelAddArea, loadingDetail} = props;
  const [editArea, setEditArea] = useState('');
  const [areaForm, setAreaForm] = useState({});
  const columnsTable = columnsTableWithProps(setEditArea, setAreaForm, cancelAddArea);
  const data = useMemo(() => list, [list]);
  const columns = useMemo(() => columnsTable, []);

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    page,
    canPreviousPage,
    canNextPage,
    pageOptions,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    'state': {pageIndex, pageSize},
  } = useTable(
    {
      columns,
      data,
      'defaultColumn': {'Filter': DefaultColumnFilter},
      'initialState': {'pageIndex': 0, 'pageSize': 10},
      'autoResetFilters': false,
    },
    useFilters,
    usePagination,
    useRowSelect
  );

  return (
    <>
      <div className="table-container">
        <Table className="interactive" striped {...getTableProps()}>
          <Table.Header>
            {headerGroups.map((headerGroup) => (
              <>
                <Table.Row key="headers" {...headerGroup.getHeaderGroupProps()}>
                  {headerGroup.headers.map((column, index) => (
                    <Table.HeaderCell
                      key={`title-${index}`}
                      textAlign="center"
                      {...column.getHeaderProps()}
                    >
                      {column.render('Header')}
                    </Table.HeaderCell>
                  ))}
                </Table.Row>
                <Table.Row key="filters" id="filters">
                  {headerGroup.headers.map((column, index) => (
                    <Table.HeaderCell
                      key={`filter-${index}`}
                      textAlign="center"
                    >
                      <Filter column={column} />
                    </Table.HeaderCell>
                  ))}
                </Table.Row>
                {addArea && (
                  <Table.Row key="new-row" className="new-register">
                    {headerGroup.headers.map((column, index) => (
                      <Table.HeaderCell
                        key={`new-area-${index}`}
                        textAlign="center"
                      >
                        <AreaFormInput
                          id={column.id}
                          areaForm={areaForm}
                          setAreaForm={setAreaForm}
                          cancelAddArea={cancelAddArea}
                          setEditArea={setEditArea}
                          addArea={addArea}
                        />
                      </Table.HeaderCell>
                    ))}
                  </Table.Row>
                )}
              </>
            ))}
          </Table.Header>
          <Table.Body {...getTableBodyProps()}>
            {!page.length && (
              <Table.Row>
                <Table.Cell colSpan={15} textAlign="center">
                  No hay datos disponibles
                </Table.Cell>
              </Table.Row>
            )}
            {page.length > 0 &&
              page.map((row, i) => {
                prepareRow(row);
                return (
                  <Table.Row key={i}>
                    {row.cells.map((cell) => {
                      if (editArea === i) {
                        return (
                          <Table.Cell
                            textAlign="center"
                            {...cell.getCellProps()}
                          >
                            <AreaFormInput
                              id={cell.column.id}
                              areaForm={areaForm}
                              setAreaForm={setAreaForm}
                              cancelAddArea={cancelAddArea}
                              setEditArea={setEditArea}
                              addArea={addArea}
                              loadingDetail={loadingDetail}
                            />
                          </Table.Cell>
                        );
                      }
                      return (
                        <Table.Cell textAlign="center" {...cell.getCellProps()}>
                          {cell.render('Cell')}
                        </Table.Cell>
                      );
                    })}
                  </Table.Row>
                );
              })}
          </Table.Body>
        </Table>
      </div>
      <TablePaginator
        data={data}
        canPreviousPage={canPreviousPage}
        pageIndex={pageIndex}
        pageOptions={pageOptions}
        pageSize={pageSize}
        canNextPage={canNextPage}
        nextPage={nextPage}
        gotoPage={gotoPage}
        previousPage={previousPage}
        setPageSize={setPageSize}
      />
    </>
  );
};

export default AreasTable;
